import {
  QueryKey,
  useMutation,
  UseMutationOptions,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { ApiErrorResponse, ApiResponse } from '@/types/api';
import { api } from '@/utils/api';

type EditFileRequest = FormData;

interface EditFileResponse {
  file: {
    id: number;
    name: string;
  };
}

const editFile = (request: EditFileRequest) => {
  return api.put<ApiResponse<EditFileResponse>>('/v2/file', request, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const useEditFile = <TError = AxiosError<ApiErrorResponse>>(
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse<EditFileResponse>>,
    TError,
    EditFileRequest,
    QueryKey
  >,
) => {
  return useMutation(editFile, {
    ...options,
  });
};

export default useEditFile;
